module.exports = __webpack_public_path__ + "static/media/4-min.b44abf71.jpg";